var bighouse = bighouse || {};

bighouse.carousel = (function () {


    function init() {

        if ($('.js-carousel').length <= 0)
            return;


        $('.js-carousel').each(function(e){
            var arrowsContainer = $(this).parent().find('.Carousel-arrows-inner');

            $(this).slick({
                slidesToShow: 3,
                slidesToScroll: 3,
                dots: false,
                lazyLoad: 'ondemand',
                focusOnSelect: false,
                infinite: true,
                autoplay: false,
                dots: false,
                appendArrows: $(arrowsContainer),
                prevArrow: '<button type="button" class="Carousel-prev"><span class="u-visuallyHidden">Previous</span></button>',
                nextArrow: '<button type="button" class="Carousel-next"><span class="u-visuallyHidden">Next</span></button>',
                responsive: [
                    {
                      breakpoint: 1024,
                      settings: {
                        slidesToShow: 2,
                        slidesToScroll: 2
                      }
                    },
                    {
                      breakpoint: 730,
                      settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1
                      }
                    }
                  ]
            });
        });
      }

    
    return {
        init: init
    };
})();